export interface CoursesSectionDataCourseProps {
  id: number;
  title: string;
  subTitle: string;
  description: string;
  btnText: string;
}

export interface CoursesSectionDataProps {
  title: string;
}

export default <CoursesSectionDataProps>{
  title: 'Nuestra ruta de aprendizaje 🚀',
};
